module.exports = __webpack_public_path__ + "static/media/logo-header-branco.ea5e184a.svg";